import React from 'react';
import Layout from './templates/DefaultLayout';

const UnauthorizedPage = () => {
    return (
        <Layout>
            <section className="flex flex-col items-center justify-center h-full">
                <h1 className="text-3xl mb-2">Access Denied</h1>
                <p className="text-lg">You do not have access to the page</p>
            </section>
        </Layout>
    );
};

export default UnauthorizedPage;